import React, { useState, useRef, useEffect } from "react"
import { Document, Page, pdfjs } from "react-pdf"
import { Flex, Spin } from "antd"
import "react-pdf/dist/esm/Page/AnnotationLayer.css"
import "react-pdf/dist/esm/Page/TextLayer.css"

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`

const PdfViewer = ({ url, height = 400 }) => {
  const [numPages, setNumPages] = useState(null)
  const [containerWidth, setContainerWidth] = useState(null)
  const containerRef = useRef(null)

  useEffect(() => {
    if (!containerRef.current) return
    const observer = new ResizeObserver((entries) => {
      if (entries[0]) setContainerWidth(entries[0].contentRect.width)
    })
    observer.observe(containerRef.current)
    setContainerWidth(containerRef.current.getBoundingClientRect().width)
    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    setNumPages(null)
  }, [url])

  return (
    <div ref={containerRef} style={{ height, overflowY: "auto" }}>
      <Document
        file={url}
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
        loading={
          <Flex justify="center" align="center" style={{ minHeight: 100 }}>
            <Spin />
          </Flex>
        }
        error={
          <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
            Unable to display PDF preview. Please download the file to view it.
          </div>
        }
      >
        {containerWidth &&
          Array.from({ length: numPages || 0 }, (_, i) => (
            <Page
              key={i + 1}
              pageNumber={i + 1}
              width={containerWidth}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          ))}
      </Document>
    </div>
  )
}

export default PdfViewer
